/* eslint-disable react/jsx-props-no-spreading */
import hoistStatics from 'hoist-non-react-statics';
import React, { Component } from 'react';
import { config } from '../../../config';

export default (WrappedComponent) => {
  class withIntercom extends Component {
    componentDidMount() {
      this.bootIntercom();
    }

    bootIntercom = () => {
      if (typeof window.Intercom === 'function') {
        window.Intercom('boot', {
          app_id: config.REACT_APP_INTERCOM_APP_ID,
        });
      }
    }

    shutdownIntercom = () => {
      if (typeof window.Intercom === 'function') {
        window.Intercom('shutdown');
      }
    }

    render() {
      const { ...props } = this.props;

      return (
        <>
          <WrappedComponent {...props} />
        </>
      );
    }
  }

  return hoistStatics(withIntercom, WrappedComponent);
};
